/**
 * Created by sam1 on 23/02/2017.
 */

export class HydrantLog {

  accountNumber: string;
  permitHolderName: string;
  permitNo: string;
  createdDate: string;
  vehicleRegistrationNo:  string;
  streetNo: string;
  streetName: string;
  suburb: string;
  kiloLitreTaken: number;
  month: string;

  constructor(obj?: any) {
    if (obj) {
      if (obj.hasOwnProperty('permitHolderName')) {
        this.permitHolderName = obj.permitHolderName.toUpperCase();
      }
      if (obj.hasOwnProperty('permitNo')) {
        this.permitNo = obj.permitNo.toUpperCase();
      }
      if (obj.hasOwnProperty('createdDate')) {
        this.createdDate = obj.createdDate;
      }
      if (obj.hasOwnProperty('vehicleRegistrationNo')) {
        this.vehicleRegistrationNo = obj.vehicleRegistrationNo.toUpperCase();
      }
      if (obj.hasOwnProperty('accountNumber')) {
        this.accountNumber = obj.accountNumber;
      }
      if (obj.hasOwnProperty('streetNo')) {
        this.streetNo = obj.streetNo;
      }
      if (obj.hasOwnProperty('streetName')) {
        this.streetName = obj.streetName;
      }
      if (obj.hasOwnProperty('suburb')) {
        this.suburb = obj.suburb;
      }
      if (obj.hasOwnProperty('kiloLitreTaken')) {
        this.kiloLitreTaken = obj.kiloLitreTaken;
      }
      if (obj.hasOwnProperty('month')) {
        this.month = obj.month;
      }
  }
  }
/*toUpperCase() {
    if (this.permitHolderName) {
      this.permitHolderName = this.permitHolderName.toUpperCase();
    }
    if (this.permitNo) {
      this.permitNo = this.permitNo.toUpperCase();
    }
    if (this.vehicleRegistrationNo) {
      this.vehicleRegistrationNo = this.vehicleRegistrationNo.toUpperCase();
    }
    if (this.streetName) {
      this.streetName = this.streetName.toUpperCase();
    }
  if (this.suburb) {
    this.suburb = this.suburb.toUpperCase();
  }
  }*/
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/hydrant-log.ts